import { render, staticRenderFns } from "./SubastaIndex.vue?vue&type=template&id=b04641fc"
import script from "./SubastaIndex.vue?vue&type=script&lang=js"
export * from "./SubastaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports